/* eslint-disable react/no-render-return-value */
import { DirectionalHint, IconButton, IContextualMenuItem } from "@nuorder/components";
import { IHeaderParams } from "ag-grid-community";
import { DATATEST } from "constants/integration";
import { formatMessage } from "lib/globalize-util";
import React from "react";
import * as ReactDOM from "react-dom";
import { DimentionActionCommands } from "../tool-panels/dimensions-tool-panel/dimension-types";

export interface ICustomHeaderParams {
    onActionInvoked: (command: DimentionActionCommands, id?: string) => void;
    readOnly?: boolean;
}
const style = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
};

interface IProps {
    name: string;
    readOnly?: boolean;
    onActionInvoked: (command: DimentionActionCommands, id?: string) => void;
}

const MoreOptions: React.FunctionComponent<IProps> = ({ name, readOnly, onActionInvoked }) => {
    const handleContextualClick = React.useCallback(
        (ev?: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>, item?: IContextualMenuItem) => {
            onActionInvoked(item.key as DimentionActionCommands);
        },
        [onActionInvoked]
    );

    return (
        <div style={style}>
            <div
                className="customHeaderLabel"
                style={{
                    width: "auto !important",
                    maxWidth: "100px",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    cursor: "pointer",
                    zIndex: 10,
                }}
            >
                {name}
            </div>
            <span
                style={{
                    backgroundColor: "#2985ce",
                    color: "white",
                    padding: "3px 5px",
                    borderRadius: "5px",
                    margin: "0px 5px",
                    fontWeight: 400,
                    fontSize: "x-small",
                }}
            >
                {formatMessage("User")}
            </span>
            {!readOnly && (
                <IconButton
                    role="button"
                    className="item"
                    disabled={false}
                    aria-haspopup
                    menuIconProps={{
                        iconName: "horizKabob24",
                        style: {
                            display: "flex",
                            alignItems: "center",
                        },
                    }}
                    menuProps={{
                        directionalHint: DirectionalHint.leftCenter,
                        gapSpace: 0,
                        beakWidth: 20,
                        directionalHintFixed: false,
                        items: [
                            {
                                key: DimentionActionCommands.RenameDoorGrouping,
                                text: formatMessage("Rename door grouping"),
                                "data-test": DATATEST.ASSORTMENTS.GROUPING.COLUMN_HEADERS.CUSTOM_HEADERS.RENAME,
                            },
                            {
                                key: DimentionActionCommands.DeleteDoorGrouping,
                                text: formatMessage("Delete door grouping"),
                            },
                        ],
                        onItemClick: handleContextualClick,
                    }}
                />
            )}
        </div>
    );
};

export class CustomDoorGroupAttributeHeaderComponent {
    private agParams!: ICustomHeaderParams & IHeaderParams;
    private eGui!: HTMLDivElement;

    init(agParams: ICustomHeaderParams & IHeaderParams) {
        this.agParams = agParams;
        this.eGui = document.createElement("div");
        ReactDOM.render(
            <MoreOptions
                name={this.agParams.displayName}
                onActionInvoked={this.agParams.onActionInvoked}
                readOnly={this.agParams.readOnly}
            />,
            this.eGui
        );
    }

    getGui() {
        return this.eGui;
    }

    onSortRequested(order: "asc" | "desc" | null, event: any) {
        this.agParams.setSort(order, event.shiftKey);
    }

    destroy() {}
}
